// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bdp-date-filter {
  text-align: left;
}
.bdp-date-filter .bdp-date-filter-all {
  margin-top: 5px;
  padding-bottom: 0px;
}
.bdp-date-filter .bdp-date-filter-range {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px 5px 5px 10px;
}
.bdp-date-filter .bdp-to {
  text-align: center;
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/date-time-filter/date-time-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,eAAA;EACA,mBAAA;AACR;AAEI;EACI,sBAAA;EACA,kBAAA;EACA,yBAAA;AAAR;AAGI;EACI,kBAAA;EACA,iBAAA;AADR","sourcesContent":[".bdp-date-filter {\n    text-align: left;\n\n    .bdp-date-filter-all {\n        margin-top: 5px;\n        padding-bottom: 0px;\n    }\n\n    .bdp-date-filter-range {\n        border: 1px solid #ccc;\n        border-radius: 5px;\n        padding: 5px 5px 5px 10px\n    }\n\n    .bdp-to {\n        text-align: center;\n        padding-top: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
